import {Component, ChangeDetectionStrategy, input, linkedSignal, output} from '@angular/core';

import type {DataProtectionAnonymizeScope} from '@app/services/data-protection.service';
import {ANONYMIZE_SCOPE_OPTIONS, AnonymizeScopeOption, canonicalScope} from '../data-protection-vocabulary';

@Component({
  selector: 'app-anonymize-scope-choice',
  templateUrl: './anonymize-scope-choice.component.html',
  styleUrls: ['./anonymize-scope-choice.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: []
})
export class AnonymizeScopeChoiceComponent {
  readonly idPrefix = input('dp-scope');
  readonly disabled = input(false);
  readonly value = input<DataProtectionAnonymizeScope[] | null>(null);
  readonly valueChange = output<DataProtectionAnonymizeScope[]>();
  options = ANONYMIZE_SCOPE_OPTIONS;
  /** The scope ticked: the bound value until a box is ticked, always with the advocates. */
  readonly selected = linkedSignal(() => canonicalScope(this.value() || []));

  isChecked(option: AnonymizeScopeOption): boolean {
    return option.locked || this.selected().indexOf(option.value) !== -1;
  }

  toggle(option: AnonymizeScopeOption, checked: boolean): void {
    if (option.locked || this.disabled()) {
      return;
    }
    const selected = this.selected();
    const next = checked ? selected.concat(option.value) : selected.filter((v) => v !== option.value);
    this.selected.set(canonicalScope(next));
    this.valueChange.emit(this.selected());
  }
}
